import React from 'react';
import ReactDOM from 'react-dom/client';

import 'suneditor/dist/css/suneditor.min.css';
import './styles/tailwind.css';
import './styles/globals.scss';
import { App } from './App';

export const DEFAULT_EMPTY = {};

const rootEl = document.getElementById('root');

// Replace blue splash with a white page loader as soon as JS runs,
// so users never sit on a blank blue screen while React/auth boot.
if (rootEl) {
  rootEl.innerHTML = `
    <div class="app-boot-loader" role="status" aria-label="Loading">
      <div class="app-boot-loader__spinner" aria-hidden="true"></div>
    </div>
  `;
}

// eslint-disable-next-line react/prop-types
ReactDOM.createRoot(rootEl).render(<App />);
